// import store from '@/store'
import {mapGetters} from 'vuex'
export default {
  install(Vue) {
    Vue.mixin({
      computed:{
        ...mapGetters(['view'])
      }
    });
  },
};
